import { c as _c } from "react/compiler-runtime";
import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import CreateDropReplying from "./CreateDropReplying";
interface CreateDropReplyingWrapperProps {
  readonly activeDrop: ActiveDropState | null;
  readonly submitting: boolean;
  readonly dropId: string | null;
  readonly onCancelReplyQuote: () => void;
}
const CreateDropReplyingWrapper: React.FC<CreateDropReplyingWrapperProps> = t0 => {
  const $ = _c(7);
  const {
    activeDrop,
    submitting,
    dropId,
    onCancelReplyQuote
  } = t0;
  let t1;
  if ($[0] !== activeDrop || $[1] !== dropId || $[2] !== onCancelReplyQuote || $[3] !== submitting) {
    t1 = activeDrop && activeDrop.drop.id !== dropId && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: "auto"
    }} exit={{
      opacity: 0,
      height: 0
    }} transition={{
      duration: 0.3
    }}><CreateDropReplying drop={activeDrop.drop} action={activeDrop.action} onCancel={onCancelReplyQuote} disabled={submitting} /></motion.div>;
    $[0] = activeDrop;
    $[1] = dropId;
    $[2] = onCancelReplyQuote;
    $[3] = submitting;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default CreateDropReplyingWrapper;